import React from 'react'
import PropTypes from 'prop-types'
import { RecentProjectCardItem } from '@components/custom'
import './RecentProjects.scss'

const RecentProjects = props => {
  const { recentProjects, userId, deleteProject, onSelectFavorite } = props
  const lastFourProjects = recentProjects.length && recentProjects.slice(0, 4)
  const navigateToPreview = id => {
    props.history.push(`/preview/${id}`)
  }

  return (
    <div className="recent-projects" data-testid="recent-projects">
      {lastFourProjects.length > 0 ? (
        <>
          {lastFourProjects.map((project, index) =>
            <RecentProjectCardItem key={index} projectData={project} onClick={() => navigateToPreview(project.id)} userId={userId} deleteProject={deleteProject} onSelectFavorite={onSelectFavorite} />
          )}
        </>
      ) : (
        <div className="no-recent-projects">No Recent Projects Available</div>
      )}
    </div>
  )
}

RecentProjects.propTypes = {
  recentProjects: PropTypes.array,
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  userId: PropTypes.string,
  deleteProject: PropTypes.func,
  onSelectFavorite: PropTypes.func
}

export default RecentProjects
